import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import 'ol/ol.css';
import { Tile, Vector as VectorLayer } from 'ol/layer.js';
import { Vector as VectorSource } from 'ol/source.js';
import { fromLonLat } from 'ol/proj';
import { Id, IId } from "NSwag/ServerClient/Client.nswag";
import olMap from 'ol/Map';
import TileLayer from 'ol/layer/Tile';
import LayerType from 'ol/LayerType';
import BaseLayer from 'ol/layer/Base';

interface IProps {
    map: olMap,
    name: string,
    children: any
}

interface IState {
    vectorLayer: VectorLayer | null,
    vectorLayerSource: VectorSource | null
}

/*
 * Define the actual component, its state if it has one
 * and its logic
 */
class OpenLayersVectorLayer extends React.Component<IProps, IState> {

    id: IId;

    state!: IState;

    props!: IProps;

    /**
    * Set the initial state
    * @param { object } props the set of properties associated with this component
    * @return { void }
    */
    constructor(props: IProps) {
        super(props);
        this.id =
        {
            name: props.name,
            resourceType: "VectorLayer",
            centerId: "OL",
            providerName: "OL"
        };

        this.state = {
            vectorLayer: null,
            vectorLayerSource: null
        }
    }

    /**
    * Called with the compoennt is added to the DOM
    * @return { void}
    */
    componentDidMount = () => {
        if (this.props.map != null && this.tileLayerRendered()) {
            this.addVectorLayer();
        }
    }

    /**
    * Called when the component updates in the DOM
    * @return { void }
    */
    componentDidUpdate = (prevProps: IProps) => {
        if ((prevProps.map == null && this.props.map && this.tileLayerRendered())
            || (this.props.map && !this.state.vectorLayer && this.tileLayerRendered())) {
            this.addVectorLayer();
        }
    }

    tileLayerRendered = (): boolean => {
        // We need to ensure the tile layer is rendered first or else it will
        // cover the vector layer
        let rendered: boolean = false;
        if (this.props.map) {
            let layers = this.props.map.getLayers().getArray();
            rendered = layers.filter(l => l.getType() == LayerType.TILE).length > 0;
        }

        return rendered;
    }

    /**
     * Method fired before component is re-rendered to determine if component should be re-rendered or not
     * @returns {boolean} - true if it should be re-rendered; false if not.s
     */
    shouldComponentUpdate = () => {
        let retVal = true;
        return retVal;
    }

    /**
    * Creates a new vectory layer and adds it to the map
    * @return { void }
    */ 
    addVectorLayer = () => {
        let vectorLayerSource = new VectorSource({ wrapX: false });

        let vectorLayer = new VectorLayer({
            source: vectorLayerSource
        });

        this.props.map.addLayer(vectorLayer);
        this.setState({ vectorLayer, vectorLayerSource});
    }

    /**
    * Iterates over the children of this component, passes them a reference to the map, which triggers their render methods
    * @return { React.Component } returns a list of children that have been rendered
    */
    renderChildren = () => {
        if (this.props.map != null && this.state.vectorLayer != null && this.state.vectorLayerSource != null) {

            const { vectorLayer, vectorLayerSource } = this.state;
            const { children, map } = this.props;

            if (!children) return;
            return React.Children.map(children,
                c => {
                    if (!c) return;
                    return React.cloneElement(c,
                        {
                            map,
                            vectorLayer,
                            vectorLayerSource
                        });
                });
        }
    }

    /**
    *  Define how the component will render (html elements or other components)
    * @return { React.Component } returns a list of children that have been rendered
    */
    render() {
        return <div>{this.renderChildren()}</div>;
    }
}

/*
 * Make our component the default export object and attach the styles defined
 */
export default OpenLayersVectorLayer